import React  from "react";
import { Card, CardBody } from "reactstrap";
import MaterialTable from 'material-table';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

var Utils = require('Utils');

var sdf = require('date-format');

export const  AttendanceListCard = ( { attendanceList, persona } ) => {
 
  let total = 0;
  let attendanceFixed = attendanceList.map( (att) => {
    att.fmtDate = sdf.asString('dd/MM/yy', new Date(att.date)) ;
    att.fmtQty = (parseFloat(att.qty)===0?'-':( parseFloat(att.qty)===0.5?'½':parseInt(att.qty) )) ;
    total = total +  parseFloat(att.qty);
    return att;
  }) ;

  let fmtTotal =  '';
  if (total === 0) fmtTotal = '-';
  else if (total === 0.5) fmtTotal = '½';
  else {
    fmtTotal = parseInt(total) + (parseFloat(total) - parseInt(total) === 0.5?' ½':'');
  }
  

  attendanceFixed.push(
      { description: 'Total insasistencias a la fecha', 
        fmtQty: fmtTotal ,
        // fmtDate: 'nana'
      })

  let cols = [ 
        { title: 'Fecha', field: 'fmtDate' },
        { title: 'Descripción', field: 'description' },
        { title: 'Cantidad', field: 'fmtQty', align: 'right' }
      ];

    return (
        <>
       
           <Card>
          
           <CardBody>
                <MaterialTable
                        title={'Inasistencias'}
                        columns={cols}
                        data={ attendanceFixed }        
                        options={{
                          exportButton: {
                              csv: false,
                              pdf: true
                          } ,
                          search: false,
                          paging: false,


                          exportPdf: (columns, data) => {
                            const doc = new jsPDF();
                            const columnTitles = columns
                                .map(columnDef => columnDef.title);
                            const pdfData = data.map(rowData =>
                                  columns.map(columnDef => rowData[columnDef.field]),
                                );
                            doc.text('Inasistencias de ' + 
                                    Utils.capitalize(persona.last_name + ", " + persona.name)
                                    + " al " +  sdf.asString('dd/MM/yy', new Date()) 
                                    ,10,10) ;

                            doc.autoTable({
                               head: [columnTitles],
                               body: pdfData
                                
                            });
                          
                            doc.save('Borrador de inasistencias de ' + 
                                    Utils.capitalize(persona.last_name + ", " + persona.name)
                                    + `.pdf`);
                          }

                      }}
                      localization={{
                          toolbar: {
                            exportPDFName: "Exportar PDF"
                          }
                        }}
                    />

           </CardBody>
         </Card>
        </>
    );
  }


